import { FormTemplate } from "components/modal/templates";
import { CustomNumberField, getCustomNumberConfig } from "components/shared/form";
import { trailerNumber } from "helpers/validators";
import React from "react";
import { apply } from "sources/books/hiredTrailers";
import { config, initialState } from "./config";

class HiredTrailerForm extends FormTemplate {
    getNumberConfig = (useCustomNumber) => {
        return getCustomNumberConfig({
            number: this.props.config.number,
            useCustomNumber,
            numberValidator: trailerNumber,
        });
    };

    getValidationConfig = (state) => ({
        ...this.props.config,
        number: this.getNumberConfig(!!state.useCustomNumber),
    });

    sendRequest = (stateData) => {
        const { useCustomNumber, ...data } = stateData;
        return apply(data);
    };

    setCustomNumberMode = ({ value }) => {
        const number = value ? this.state.number : "";
        const nextState = { ...this.state, number, useCustomNumber: value };
        const isValid = this.isValidForm(nextState);
        this.setState({ number, useCustomNumber: value, ...(isValid ? { isValid: true } : {}) });
    };

    renderBodyInner = () => {
        const { counterpartyIds, number, typeId, brandTypeId } = this.props.config;
        const useCustomNumber = !!this.state.useCustomNumber;
        return (
            <>
                {this.renderSelect(counterpartyIds)}
                <CustomNumberField
                    number={number}
                    numberValidator={trailerNumber}
                    onCustomNumberChange={this.setCustomNumberMode}
                    renderField={this.renderField}
                    useCustomNumber={useCustomNumber}
                />
                {this.renderSelect(typeId)}
                {this.renderSelect(brandTypeId)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <HiredTrailerForm
        {...props}
        config={config}
        initialState={{ ...initialState, useCustomNumber: false, ...(props.data || {}) }}
    />
);

export default ConfiguredModal;
